import { IComponentBaseProps } from '../models/IComponentBaseProps';

export function stripBaseProps<TProps extends IComponentBaseProps, TReturnType>(props: TProps): TReturnType {
	const {
		className,
		componentStyle,
		theme,
		configuration,
		hide,
		hideDisclaimers,
		componentStyleProps,
		displayName,
		__docgenInfo,
		analyticsContext,
		suppressAnalytics,
		"data-selector": dataSelector,
		"data-selectors": dataSelectors,
		...rest
	} = props;
	return rest as TReturnType;
}
